// @flow
import React from "react";
import { Text } from "@components";

export default function materialIcon(icon: string, color?: string, tooltip?: string) {
  return (
    <Text className="material-icons" tooltip={tooltip} color={color || "primary"} text={icon} />
  );
}
